import { getPointParameter } from "./get-points-parameter.js";
import { isPolyLine } from "./guard.js";
/**
 * Returns length of line, polyline or between two points
 *
 * @param aOrLine Point A, line or polyline (array of lines)
 * @param pointB Point B, if first parameter is a point
 * @returns Length (total accumulated length for arrays)
 */
//eslint-disable-next-line func-style
export function length(aOrLine, pointB) {
    if (isPolyLine(aOrLine)) {
        const sum = aOrLine.reduce((accumulator, v) => length(v) + accumulator, 0);
        return sum;
    }
    if (aOrLine === undefined)
        throw new TypeError(`Parameter 'aOrLine' is undefined`);
    const [a, b] = getPointParameter(aOrLine, pointB);
    const x = b.x - a.x;
    const y = b.y - a.y;
    if (a.z !== undefined && b.z !== undefined) {
        const z = b.z - a.z;
        return Math.hypot(x, y, z);
    }
    else {
        return Math.hypot(x, y);
    }
}
